/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Loading_OlderInputs */



/**
* | output |
* | --- |
* | "Loading earlier messages…" |
*
* @param {Chat_Loading_OlderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_loading_older = /** @type {((inputs?: Chat_Loading_OlderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Loading_OlderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Eerdere berichten laden…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des messages précédents…")
	return /** @type {LocalizedString} */ ("Loading earlier messages…")
});